import {
  Box,
  Button,
  Checkbox,
  createStyles,
  List,
  Modal,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import React, { useState } from "react";
import { updateProfile } from "../../services/profile";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useStyles = createStyles(() => ({
  mainbox: {
    background: "#FFF",
    marginTop: "40px",
    // padding: "13px 19px",
    // width:'80%'
  },

  dflex: {
    display: "flex",
    justifyContent: "flex-end",
  },

  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },
}));

const BillingAgree = ({ open, setOpen }) => {
  const [isChecked, setIsChecked] = useState(false);

  const { profile } = useSelector((state) => state?.profile);

  const { classes } = useStyles();

  const[loading,setLoading]=useState(false)

  const handleClose = () => {
    setOpen(false);
  };

  const navigate=useNavigate()

  // Handler for checkbox change
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const submit = async () => {

    setLoading(true)
    try {
      // let obj = {
      //     name: values?.name,
      //   };

      let payload = {
        ...profile,
        billingAgree: isChecked,
      };

      console.log("payload", payload);

      let response = await updateProfile(payload);

      // console.log('response',response);

      if (response) {
        handleClose();
        navigate('/home/billing')
      }

      setLoading(false)
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <Modal
        // className={classes.addMedicationModal}
        opened={open}
        size={1000}
        title="Terms and Agreement"
        shadow="md"
        onClose={handleClose}
        overlayProps={{ blur: 3 }}
        radius={"lg"}
        zIndex={1000}
        styles={{
          title: {
            color: "#171717",
            fontSize: "28px",
            fontWeight: "600",
          },
        }}
        centered
      >
        <Box className={classes.mainbox}>
          <Stack spacing="md">
            <Title order={2}>Ogiso.io Billing Terms and Conditions</Title>
            <Text size="sm" fw={600}>
              Effective Date: 05/01/2025
            </Text>

            <Text size="sm" fw={600}>
              These Terms and Conditions ("Terms") govern your use of the
              Ogiso.io billing platform (“Service”), operated by Ogiso, Inc.
              (“Ogiso,” “we,” “us,” or “our”). By accessing or using our billing
              services, you agree to be bound by these Terms. If you do not
              agree to these Terms, you may not use the Service
            </Text>

            <Title order={3}>1. Billing Services Overview</Title>
            <Text fw={600}>
              Ogiso.io provides billing infrastructure for healthcare providers
              and facilities, enabling claims submission to Medicaid and other
              insurance providers, as well as direct patient invoicing and
              payment collection.
            </Text>
            <Text fw={600}>Services may include:</Text>
            <List withPadding>
              <List.Item>Insurance claims management</List.Item>
              <List.Item>Medicaid claims submission</List.Item>
              <List.Item>Invoice generation and delivery to patients</List.Item>
              <List.Item>Payment processing via secure gateways</List.Item>
              <List.Item>Account reconciliation and reporting</List.Item>
              <List.Item>Claims Verification</List.Item>
            </List>

            <Title order={3}>2. Eligibility</Title>
            <List withPadding>
              <List.Item>
                You are authorized to act on behalf of a healthcare provider or
                facility.
              </List.Item>
              <List.Item>
                You are compliant with HIPAA and all relevant local, state, and
                federal healthcare regulations.
              </List.Item>
              <List.Item>
                You provided the services you are submitting the claim for.
              </List.Item>
            </List>

            <Title order={3}>3. Payment Terms</Title>
            <Title order={4}>3.1 Invoice Generation</Title>
            <Text fw={600}>
              Invoices generated through Ogiso.io must accurately reflect
              services rendered, with complete and truthful data.
            </Text>

            <Title order={4}>3.2 Insurance Claims</Title>
            <Text fw={600}>
              Ogiso.io facilitates the submission of claims but does not
              guarantee reimbursement. All reimbursements are subject to payer
              review and policy.
            </Text>

            <Title order={4}>3.3 Patient Payments</Title>
            <Text fw={600}>
              Ogiso.io may facilitate patient invoicing and payment collection.
              It is the responsibility of the provider to ensure that patients
              are informed of their financial responsibility.
            </Text>

            <Title order={4}>3.4 Transaction Fees</Title>
            <Text fw={600}>
              Ogiso.io may charge fees for billing transactions, payment
              processing, invoice processing or service subscriptions. All fees
              will be communicated in advance and reflected in your billing
              dashboard..
            </Text>

            <Title order={3}>4. Compliance and Data Privacy</Title>
            <Title order={4}>4.1 HIPAA</Title>
            <Text fw={600}>
              All data entered or processed through Ogiso.io must comply with
              HIPAA regulations. We implement administrative, technical, and
              physical safeguards to protect PHI (Protected Health
              Information)..
            </Text>

            <Title order={4}>4.2 Data Ownership</Title>
            <Text fw={600}>
              You retain ownership of all data entered into the system. Ogiso.io
              acts as a data processor and will not share or sell your data.
            </Text>

            <Title order={3}>5. Account Management</Title>
            <List withPadding>
              <List.Item>
                You are responsible for keeping your account credentials secure.
              </List.Item>
              <List.Item>
                Notify us immediately in case of unauthorized use.
              </List.Item>
            </List>

            <Title order={3}>6. Termination</Title>
            <Text fw={600}>
              Ogiso.io reserves the right to suspend or terminate your access to
              billing services for.
            </Text>
            <List withPadding>
            <List.Item>Violation of these Terms.</List.Item>
            <List.Item>Fraudulent billing activities.</List.Item>
            <List.Item>Failure to pay applicable fees.”</List.Item>
            </List>

            <Title order={3}>7. Disclaimers and Limitations</Title>
            <List withPadding>
              <List.Item>
                Ogiso.io is not responsible for denied claims or failed
                reimbursements.
              </List.Item>
              <List.Item>
                We provide no guarantee on payment timelines.
              </List.Item>
              <List.Item>Service is “as is” and “as available.”</List.Item>
            </List>

            <Title order={3}>8. Modifications</Title>
            <Text fw={600}>
              We reserve the right to update these Terms at any time. Updated
              versions will be posted on our website with an updated effective
              date. Continued use of the Service after changes constitutes
              acceptance..
            </Text>

            <Title order={3}>9. Governing Law</Title>
            <Text fw={600}>
              These Terms are governed by and shall be construed in accordance
              with the laws of the State of Arizona, where Ogiso, Inc. is
              headquartered, and the laws of the state in which the healthcare
              provider or facility using the Service operates, without regard to
              conflict of law principles. Users of the Service must also comply
              with all applicable federal laws and regulations, including but
              not limited to HIPAA, CMS guidelines, and applicable healthcare
              billing standards.
            </Text>

            <Title order={3}>Dispute Resolution</Title>
            <Text fw={600}>
              In the event of any dispute, controversy, or claim arising out of
              or relating to these Terms, the parties agree to first attempt to
              resolve the matter through good faith negotiations. If resolution
              cannot be reached within 30 days, the parties agree to submit the
              dispute to binding arbitration under the rules of the American
              Arbitration Association (AAA). The arbitration will take place in
              Phoenix, Arizona, or a mutually agreed location, and the decision
              of the arbitrator(s) shall be final and enforceable in any court
              of competent jurisdiction.
            </Text>
            <Text fw={600}>
              Nothing in this section prevents either party from seeking
              injunctive or equitable relief in a court of law where
              appropriate, especially in matters involving unauthorized data
              access or misuse of intellectual property.
            </Text>
            <Title order={3}>10. Contact</Title>
            <Text fw={600}>
              For questions or concerns regarding billing or these Terms,
              contact us at:
            </Text>
            <Text fw={600}>
              <strong>Ogiso, Inc.</strong>
              <strong>Email:</strong> support@ogiso.io
              <br />
              <strong>Phone:</strong> 7576000297
            </Text>
          </Stack>

          <Checkbox
            style={{
              marginTop: "37px",
              marginBottom: "37px",
              fontSize: "16px",
              fontWeight: "400",
              color: "#737373",
              fontFamily: "Inter, sans-serif",
            }}
            checked={isChecked}
            label="I have read and understood the terms and conditions"
            onChange={handleCheckboxChange}
            labelProps={{
              style: {
                fontSize: "16px",
                fontWeight: "400",
                color: "#737373",
                fontFamily: "Inter, sans-serif",
              },
            }}
          ></Checkbox>

          <Box className={classes.dflex}>
            <Button
            loading={loading}
              disabled={!isChecked}
              bg={"#FFAF4A"}
              c={"#171717"}
              onClick={submit}
              className={classes.button}
            >
              I Agree
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default BillingAgree;
